import { render } from "./About.vue?vue&type=template&id=5d0e1b14"
const script = {}
script.render = render

export default script